import client from '../../apollo';
import { gql } from '@apollo/client'
import { setError, logout } from '../../actions/session';
export const ADD_DATA_CUT_TO_RULE = 'ADD_DATA_CUT_TO_RULE';
export const CREATE_RULE = 'CREATE_RULE';
export const DELETE_RULE = 'DELETE_RULE';
export const DELETE_DATA_CUT_FROM_RULE = 'DELETE_DATA_CUT_FROM_RULE';
export const RULES_FETCH_SUCCESS = 'RULES_FETCH_SUCCESS';
export const SET_SELECTED_RULE = 'SET_SELECTED_RULE';
export const UPDATE_DATA_CUT_TO_RULE = 'UPDATE_DATA_CUT_TO_RULE';
export const UPDATE_RULE = 'UPDATE_RULE';
export const UPDATE_RULES = 'UPDATE_RULES';
export const APPLY_RULE_TO_JOBS = 'APPLY_RULE_TO_JOBS';
export const SET_RULE_NAME = 'SET_RULE_NAME';
export const START_EDITING_RULE_NAME = 'START_EDITING';
export const SET_TEMP_RULE_NAME = 'SET_TEMP_RULE_NAME';
export const CANCEL_RULE_NAME_EDITING = 'CANCEL_RULE_NAME_EDITING';
export const SAVE_RULE_NAME = 'SAVE_RULE_NAME';
export const UPDATE_AUDIT_INFO = 'UPDATE_AUDIT_INFO';
export const VIEW_PRICED_JOBS = 'VIEW_PRICED_JOBS';
export const VIEW_NOT_PRICED_JOBS = 'VIEW_NOT_PRICED_JOBS';
export const CLEAR_SELECTED_RULE = 'CLEAR_SELECTED_RULE';

export function clearSelectedRule() {
  return async dispatch => {
    dispatch({
      type: CLEAR_SELECTED_RULE
    });
  };
}

export function getAuditInfo(selectedRule) {
  return async dispatch => {
    try {
      const query = gql`
        query rule($id: ID!) {
          rule(id: $id) {
            id
            name
            lastModified
            lastModifiedBy {
              firstName
              lastName
            }
          }
        }
      `;

      const response = await client.query({
        query,
        variables: { id: selectedRule.id },
        fetchPolicy: 'network-only'
      });

      if (
        response === 'Unauthorized' ||
        (response.body && response.body === 'Unauthorized') ||
        (response.data && response.data === 'Unauthorized')
      ) {
        dispatch(logout());
      } else {
        const { data } = response;
        dispatch({ type: UPDATE_AUDIT_INFO, data: data.rule });
      }
    } catch (error) {
      console.log(error);
    }
  };
}

export function addDataCutToRule(selectedRule, dataCut, priority) {
  return async dispatch => {
    try {
      const mutation = gql`
        mutation addDataCutToRule($ruleId: ID!, $dataCutId: ID!, $priority: Int!) {
          addDataCutToRule(ruleId: $ruleId, dataCutId: $dataCutId, priority: $priority) {
            id
          }
        }
      `;

      const { data } = await client.mutate({
        mutation,
        variables: {
          ruleId: selectedRule.id,
          dataCutId: dataCut.id,
          priority
        }
      });

      dispatch({
        type: ADD_DATA_CUT_TO_RULE,
        id: data.addDataCutToRule.id,
        priority,
        dataCut
      });
    } catch (error) {
      console.log(error);
    }
  };
}

export function createRule(name) {
  return async dispatch => {
    try {
      const mutation = gql`
        mutation createRule($name: String!) {
          createRule(name: $name) {
            id
            name
            created
            createdBy {
              firstName
              lastName
            }
            dataCuts {
              id
            }
          }
        }
      `;
      const { data } = await client.mutate({
        mutation,
        variables: { name }
      });

      dispatch({
        type: CREATE_RULE,
        data: data.createRule
      });
    } catch (error) {
      console.log(error);
    }
  };
}

export function deleteDataCutFromRule(selectedRule, dataCutConnectionId) {
  return async dispatch => {
    try {
      const mutation = gql`
        mutation deleteDataCutFromRule($dataCutConnectionId: ID!) {
          deleteDataCutFromRule(dataCutConnectionId: $dataCutConnectionId) {
            success
            message
          }
        }
      `;
      await client.mutate({
        mutation,
        variables: { dataCutConnectionId }
      });

      dispatch({ type: DELETE_DATA_CUT_FROM_RULE, data: dataCutConnectionId });
    } catch (error) {
      console.log(error);
    }
  };
}

export function deleteRule(id) {
  return async dispatch => {
    try {
      const mutation = gql`
        mutation deleteRules($id: ID!) {
          deleteRule(id: $id) {
            success
            message
          }
        }
      `;

      await client.mutate({
        mutation,
        variables: { id }
      });
      dispatch({ type: DELETE_RULE, data: id.toString() });
    } catch (error) {
      console.log(error);
    }
  };
}

export function getRules() {
  return async dispatch => {
    try {
      const query = gql`
        query rules {
          rules {
            edges {
              id
              name
              lastModified
              lastModifiedBy {
                firstName
                lastName
              }
              lowerLimitCO
              lowerLimitEE
            }
          }
        }
      `;

      const { data } = await client.query({
        query,
        fetchPolicy: 'network-only'
      });

      dispatch({
        type: RULES_FETCH_SUCCESS,
        rules: data.rules.edges
      });
    } catch (error) {
      console.log(error);
    }
  };
}

export function searchRules(text) {
  return async dispatch => {
    try {
      const query = gql`
        query rules($text: String!) {
          rules(search: { text: $text }) {
            edges {
              id
              name
              lastModified
              lastModifiedBy {
                firstName
                lastName
              }
            }
          }
        }
      `;

      const { data } = await client.query({
        query,
        variables: { text },
        fetchPolicy: 'network-only'
      });
      dispatch({ type: UPDATE_RULES, data: data.rules.edges });
    } catch (error) {
      console.log(error);
    }
  };
}

export function setSelectedRule(rule) {
  return async dispatch => {
    try {
      const query = gql`
        query rule($id: ID!) {
          rule(id: $id) {
            id
            name
            lastModified
            lowerLimitCO
            lowerLimitEE
            lastModified
            lastModifiedBy {
              firstName
              lastName
            }
            dataCuts {
              id
              priority
              dataCut {
                name
                id
                survey {
                  id
                  name
                  code
                  year
                  publisher
                }
                currency {
                  code
                }
              }
            }
          }
        }
      `;

      const { data } = await client.query({
        query,
        variables: { id: rule.id },
        fetchPolicy: 'network-only'
      });

      dispatch({ type: SET_SELECTED_RULE, data: data.rule });
    } catch (error) {
      console.log(error);
    }
  };
}

export function updateDataCutToRule(dataCutConnectionId, priority) {
  return async dispatch => {
    try {
      const mutation = gql`
        mutation updateDataCutToRule($dataCutConnectionId: ID!, $priority: Int!) {
          updateDataCutToRule(dataCutConnectionId: $dataCutConnectionId, priority: $priority) {
            id
            priority
          }
        }
      `;

      const { data } = await client.mutate({
        mutation,
        variables: {
          dataCutConnectionId,
          priority
        }
      });

      dispatch({
        type: UPDATE_DATA_CUT_TO_RULE,
        data: data.updateDataCutToRule
      });
    } catch (error) {
      console.log(error);
    }
  };
}

export function updateRule({ id, name, lowerLimitEE, lowerLimitCO }) {
  return async dispatch => {
    try {
      const mutation = gql`
        mutation updateRule($id: ID!, $name: String, $lowerLimitEE: Int, $lowerLimitCO: Int) {
          updateRule(id: $id, name: $name, lowerLimitEE: $lowerLimitEE, lowerLimitCO: $lowerLimitCO) {
            id
            name
            lowerLimitEE
            lowerLimitCO
          }
        }
      `;

      const { data } = await client.mutate({
        mutation,
        variables: { id, name, lowerLimitEE, lowerLimitCO }
      });

      dispatch({ type: UPDATE_RULE, data: data.updateRule });
    } catch (error) {
      console.log(error);
    }
  };
}

export function applyRuleToJobs(ruleId, jobIds, strategy) {
  return async dispatch => {
    try {
      const mutation = gql`
        mutation applyRuleToJobs($ruleId: ID!, $jobIds: [ID!]!, $strategy: RuleApplicationStrategy!) {
          applyRuleToJobs(ruleId: $ruleId, jobIds: $jobIds, strategy: $strategy) {
            priced {
              job {
                id
                title
                code
                codeKey
                currency
              }
              base50th
            }
            skipped {
              job {
                id
                title
                code
                codeKey
              }
              reason
            }
          }
        }
      `;

      const { data } = await client.mutate({
        mutation,
        variables: { ruleId, jobIds, strategy }
      });

      dispatch({ type: APPLY_RULE_TO_JOBS, data: data.applyRuleToJobs });
    } catch (error) {
      console.log(error);
    }
  };
}

export function viewPricedJobs() {
  return async dispatch => {
    dispatch({ type: VIEW_PRICED_JOBS });
  };
}

export function viewNotPricedJobs() {
  return async dispatch => {
    dispatch({ type: VIEW_NOT_PRICED_JOBS });
  };
}

export function setRuleName(ruleName) {
  return { type: SET_RULE_NAME, ruleName };
}

export function setTempRuleName(name) {
  return { type: SET_TEMP_RULE_NAME, name };
}

export function startEditingRuleName() {
  return { type: START_EDITING_RULE_NAME };
}

export function cancelRuleNameEditing(name) {
  return { type: CANCEL_RULE_NAME_EDITING, name };
}

export function saveRuleName(name) {
  return { type: SAVE_RULE_NAME, name };
}
